const convertOrderHash = (str, forward) => {
  if (forward) {
    return encodeURIComponent(str); //str.replace(/#/g, 'hash');
  } else {
    return decodeURIComponent(str); //str.replace(/hash/g, '#');
  }
};
export default convertOrderHash;
